/** @format */

// This class is used to identify when a data is not what we expect to build the application.
// E.g: If it is a initial state or when a error occur is some endpoint and there’s not data to store
//
// Refactor approach (to be tested)
// - Remove initial state using empty class elements.
// - Updating validation checking for truthy values.
export class InvalidResponse {}
